// removed by extract-text-webpack-plugin
module.exports = {"Icon":"icons__Icon__2TaEk","Globe":"icons__Globe__2YK_s","Locked":"icons__Locked__21UyZ","Unlocked":"icons__Unlocked__2jzdl"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/ContentBox/Icons/icons.css
// module id = 903
// module chunks = 2